import * as Sentry from '@sentry/react';

let sentryInitialized = false;

export const initSentry = () => {
  // Prevent multiple initializations
  if (sentryInitialized) {
    return;
  }

  // Only initialize Sentry in production
  if (process.env.NODE_ENV === 'production') {
    sentryInitialized = true;
    Sentry.init({
      dsn: process.env.VITE_SENTRY_DSN,
      environment: process.env.NODE_ENV,
      sendDefaultPii: true,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // 10% of sessions will be recorded
      replaysOnErrorSampleRate: 1.0, // 100% of sessions with an error will be recorded
      
      beforeSend(event, hint) {
        // Filter out development errors
        if (process.env.NODE_ENV === 'development') {
          return null;
        }
        
        // Filter out network errors that are expected
        if (event.exception?.values?.[0]?.type === 'ChunkLoadError') {
          return null;
        }
        
        return event;
      },
    });
  }
};

export const logError = (error: Error, context?: Record<string, any>) => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureException(error, {
      contexts: {
        custom: context,
      },
    });
  } else {
    console.error('Error:', error, context);
  }
};

export const logEvent = (eventName: string, data?: Record<string, any>) => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.addBreadcrumb({
      message: eventName,
      level: 'info',
      data,
    });
  } else {
    console.log('Event:', eventName, data);
  }
};